import { FDBodyText } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { withValueArray } from 'Helpers/MetaOverride';
import HeadlineTextLarge from 'Components/ComponentLibrary/Atoms/Text/HeadlineTextLarge';
import Image from 'Context/AnnouncementContext/Dialog/DialogContent/Image';

export default buildFacetDesignOverride()
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDBodyText),
  }, overrideReadOnly)
  .nameOverride(['partnerText'], {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
  }, overrideReadOnly)
  .nameOverride('partnerImageURL', {
    _component: () => Image,
    _customProps: { noBorderRadius: true },
  }, overrideReadOnly);
